import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';
import { createPublicScreenerResultPost } from '@/services/api/requests/public-screener';
import { TPublicScreenerFormForBE } from '@/types/PublicScreener.types';

const useSubmitScreenerResult = (orgSlug: string, turnstileToken: string | null, onSuccessCallback?: (submissionId: string) => void, ) => {
  const toast = useToast();
  const queryClient = useQueryClient();


  const { isPending, mutate, isSuccess } = useMutation<
    any,
    TCustomAxiosError,
    { formData: TPublicScreenerFormForBE },
    string
  >({
    mutationKey: ['submit-screener-result', orgSlug, turnstileToken],
    mutationFn: async ({ formData }: { formData: TPublicScreenerFormForBE }) => {
      if (!orgSlug || !turnstileToken) {
        throw new Error('Organization slug and Turnstile token are required');
      }

      const { data: postData } = await createPublicScreenerResultPost({ orgSlug, data: formData, turnstileToken });

      return postData.submissionId;
    },
    onSuccess: (submissionId: string) => {
      queryClient.invalidateQueries({ queryKey: ['assessments-result-average-scores'] });

      toast({
        title: 'Success',
        description: 'Screener submitted successfully',
        status: 'success',
      });

      onSuccessCallback?.(submissionId);

      window.scrollTo({ top: 0, behavior: 'instant' });
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error while submitting Screener',
      }, error);
    },
  });

  return { isPending, mutate, isSuccess };
};

export default useSubmitScreenerResult;
